import {Component, Vue} from 'vue-property-decorator'
import {
    getOutputRecordInfoById,

} from "@/api/classManage";
import commonData from "@/utils/commonData"


@Component({})
export default class ProduceInfo extends Vue {

    recordId = null //判断是否是编辑
    typeList = commonData.projectTypeArray
    // 开课时间
    isShow = null
    disabledBtn = false
    name = '' // 远程搜索name
    loading = false
    editor: any = null
    id = null
    infoData: any = {}
    email = null
    status = null
    previewVisible = false
    previewPath = ''

    created() {
        this.id = this.$route.query.id
        this.email = this.$route.query.email
        this.status = this.$route.query.status
        this.getOutputRecordInfoById()
    }


    getOutputRecordInfoById() {
        getOutputRecordInfoById(this.id).then((res: any) => {
            this.infoData = res.studentOutput
        })
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

}
